export const createAdvancedSearchConfig = ({ 
    /**keys of Datatype String. DefaultValue will be EmptyString "" */
    searchConfigStringKeys = [''],
    /**keys of Datatype Int. DefaultValue will be EmptyString 0 */
    searchConfigIntKeys = [''],
    searchConfigTVMap = [['', '']],
    searchConfigMulTVMap = [['', '']],
    searchConfigOmitKeyMap = [["", ""]],
    booleanSearchKeyLabelMap = {} }) => {
  const booleanSearchKeys = Object.keys(
    booleanSearchKeyLabelMap
  );
  const booleanSearchLabel = (key) => booleanSearchKeyLabelMap[key];
  const isBooleanSearchKey = (key) => {
    // console.log({ "booleanSearchKeys": booleanSearchKeys, key });
    // if (booleanSearchKeys.includes(key)) {
    // console.log('isBooleanSearchKey', key);
    // }
    return booleanSearchKeys.includes(key);
  }

  const tvKeys = searchConfigTVMap.map(e => e[0]);
  const findTVKey = vk => searchConfigTVMap.find(e => e?.[0] == vk)?.[1];
  const isTVKey = key => tvKeys.find(e => key == e);

  const mulTVValueKeys = searchConfigMulTVMap.map(e => e[0]);
  const findMulTVArrayKey = vk => searchConfigMulTVMap.find(e => e?.[0] == vk)?.[1];
  const isMulTVValueKey = key => mulTVValueKeys.find(e => key == e);


  const omitKeys = searchConfigOmitKeyMap.map(e => e[1]);

  const advancedSearchConfigKeys = [
    ...searchConfigStringKeys,
    ...searchConfigIntKeys,
    ...booleanSearchKeys,
  ];
  console.log('advancedSearchConfigKeys')
  console.log(advancedSearchConfigKeys)

  if (advancedSearchConfigKeys.length != Array.from(new Set(advancedSearchConfigKeys)).length) {
    const count = array =>
      array.reduce((a, b) => ({
        ...a,
        [b]: (a[b] || 0) + 1
      }), {});

    const duplicates = dict =>
      Object.keys(dict).filter((a) => dict[a] > 1)

    throw Error(`Please check the Advanced Search Config. Make sure that any Key is not declared duplicated in these declarations - searchConfigStringKeys, searchConfigIntKeys, booleanSearchKeys. The duplicates are - ${duplicates(count(advancedSearchConfigKeys))}`);
  }


  return {
    booleanSearchKeys,
    booleanSearchLabel,
    isBooleanSearchKey,

    tvKeys,
    findTVKey,
    isTVKey,

    mulTVValueKeys,
    findMulTVArrayKey,
    isMulTVValueKey,

    searchConfigStringKeys,
    searchConfigIntKeys,
    omitKeys,
    advancedSearchConfigKeys,

    findADVSearchOmitFromKey: (key) => {
      return searchConfigOmitKeyMap.find(
        (e) => e[0] == key
      )?.[1];
    },
    findADVSearchKeyFromOmit: (omit) => {
      return searchConfigOmitKeyMap.find(
        (e) => e[1] == omit
      )?.[0];
    },
    isOmitKey: (key) => {
      return searchConfigOmitKeyMap.find(
        (e) => e[1] == key
      );
    }
  }
}